import { Inject, Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  RequestFirmarDeclaracion,
  RequestGenerarFirmadoDigital,
  TramiteFirmadoId
} from '../shared/interfaces/firma_electronica';
import { API_URL } from 'lib-base';


@Injectable({
  providedIn: 'root'
})
export class TramiteFirmasElectronicasService {
  readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/tramites-firmados`;
  }

  firmarTramite(request: RequestFirmarDeclaracion): Observable<TramiteFirmadoId> {
    return this.http.post<TramiteFirmadoId>(`${this.baseUrl}/firmar-tramite`, request);
  }

  public getIPAddress(): Observable<any> {
    return this.http.get("https://api.ipify.org/?format=json");
  }

  generarTramiteFirmado(body:RequestGenerarFirmadoDigital): Observable<Blob> {
    const url = `${this.baseUrl}/documento/generar-tramite-firma-digital`;
    return this.http.post(url, body,{responseType:'blob'});
  }

  imprimirTramiteFirmado(id: number): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/descargar/tramite-firmado/${id}`, { responseType: 'blob' });
  }

  enviarTramiteFirmado(id: number): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}/enviar-correo-tramite-activado/${id}`,null);
  }

  validaFirma(solicitud: number): Observable<boolean> {
    const url = `${this.baseUrl}/valida-firma`;
    const params: HttpParams = new HttpParams().set('solicitud', solicitud);
    return this.http.get<boolean>(url, {params: params});
  }
}
